export default __webpack_public_path__ + "static/media/lep2.c71c583c.png";